import React, {
 useEffect,
} from 'react';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import ActivityEntry from 'pages/Dashboard/pages/Billing/ClaimForm/ClaimActivity/ActivityEntry';
import {
  useGetClaimLogById,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
  billingEventChannel,
  claimEventChannel,
} from 'pages/Dashboard/services/eventChannels';

type Props = {
  claimId: number;
};

export default function ClaimActivity({ claimId }: Props) {
  const { data: claimLog, refetch } = useGetClaimLogById(claimId);
  const entries = claimLog?.entries ?? [];
  const latestEntry = entries[0];

  useEffect(() => {
    const unsubscribeFromClaimLogChange = billingEventChannel.on('onClaimLogChange', (_claimId) => {
      if (_claimId === claimId) {
        refetch();
      }
    });

    return () => {
      unsubscribeFromClaimLogChange();
    };
  }, [claimId]);

  return isEmpty(entries) || isNil(latestEntry) ? null : (
    <ActivityEntry
      entry={latestEntry}
      className="border border-gray-200 rounded-lg bg-white p-3"
      onViewActivity={() => {
        claimEventChannel.emit('onClaimActivityOpen', { claimId });
      }}
    />
  );
}
